/* istanbum ignore file */

import { Injectable, ViewContainerRef } from '@angular/core';

import { Category, PcvizLayer } from '@mirage-projects/cw-models';

export interface VectorLayerDialogData {
    geometry?: string;
    category?: Category;
    color?: string;
    geomDisabled?: boolean;
    selectCategoryDisabled?: boolean;
    wksParentId?: string;
    shouldAutomaticAttrsCheck?: boolean;
    defaultLayerName?: string;
    viewContainerRef?: ViewContainerRef;
}

export interface CreateVectorLayerServiceCommon {
    createVectorLayerDialog(dialogData: VectorLayerDialogData): Promise<PcvizLayer | void>;
}

/**
 * This service contains the instance of the CreateVectorLayerService, so it can be
 * used in other places than the project viewer
 * Note: This a hack until refactoring the CreateVectorLayerService
 */
@Injectable({ providedIn: 'root' })
export class VectorLayerDialogService {
    private _vectorLayerDialogService: any;

    get serviceInstance(): CreateVectorLayerServiceCommon {
        return this._vectorLayerDialogService;
    }

    set serviceInstance(service: CreateVectorLayerServiceCommon) {
        this._vectorLayerDialogService = service;
    }
}
